import React from "react"

const Brochure = ({ className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 52 52"
		className={`fill-current ${className || ""}`}>
		<polygon fill="#FFF" points="6 41 6 6 31 6 31 13 49 13 49 48 21 48 31 41"></polygon>
		<polygon opacity="0.3" points="6 41 6 6 31 6 31 13 49 13 49 48 21 48 31 41"></polygon>
		<path d="M32,2 L32,9 L50,9 L50,49 L20,49 L20,42 L2,42 L2,2 L32,2 Z M48,11 L32,11 L32,15 L45,15 L45,17 L32,17 L32,20 L41,20 L41,22 L32,22 L32,25 L45,25 L45,27 L32,27 L32,30 L41,30 L41,32 L32,32 L32,42 L24.354,47 L48,47 L48,11 Z M28.347,42 L22,42 L22,46.151 L28.347,42 Z M45,36 L45,44 L35,44 L35,36 L45,36 Z M30,4 L4,4 L4,40 L30,40 L30,4 Z M22.4,31 L22.4,33 L8,33 L8,31 L22.4,31 Z M25.1,26 L25.1,28 L8,28 L8,26 L25.1,26 Z M24,21 L24,23 L8,23 L8,21 L24,21 Z M26,8 L26,16 L8,16 L8,8 L26,8 Z"></path>
	</svg>
)

export default Brochure
